module.exports = __webpack_public_path__ + "static/kiran-73a34d353583b5c9454f7fcba9506f52.jpg";